export const activity = {
  activityWebEmptyStateTitle: 'Noch keine Aktivität',
  activityWebEmptyStateText: 'Hier wird dein Benachrichtigungs-Feed sein',
  activitySeeAll: 'Alle anzeigen',
  in: 'in'
}
